module.exports = __webpack_public_path__ + "media/Video 104.45695baf.mp4";